<script>
export let backend;

let itemSubtype = null;
let offers = [];
let games = [];
let game = null;
let itemType = null;

function csv() {
  let csvContent = "data:text/csv;charset=utf-8,Descriptor, Url, User, Provider, Quantity, Price\n" + offers
    .map(o => o.descriptor + ',' + o.url + ',' + o.userUrl + ',' + o.quantity + ',' + o.provider + ',' + o.price)
    .join("\n");
  let encodedUri = encodeURI(csvContent);
  let link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", "avg-top3-offers.csv");
  document.body.appendChild(link); // Required for FF
  link.click();
}

function search() {
  backend.getAvgPerTop3(game.name, itemType.name)
    .then(o => offers = o)
}

backend.games()
  .then(g => games = g);

</script>
<main>
<select class="form-select" aria-label="Game select" bind:value={game}>
  <option selected on:click= {() => {game = null; itemType = null;}}>Select a game</option>
  {#each games as game}
   <option value={game}>
      {game.name}
    </option>
  {/each}
</select>
{#if game != null && game.subtypes != null && game.subtypes.length > 0}
<select bind:value={itemType} class="form-select" aria-label="Item type select" >
  {#each game.subtypes as subtype}
    <option value={subtype}>
      {subtype.name}
    </option>
  {/each}
</select>
{/if}

{#if itemType != null}
<button type="submit" class="btn btn-light mb-3" on:click|preventDefault={search}>Search</button>
{/if}
<button type="submit" class="btn btn-light mb-3" on:click|preventDefault={csv}>CSV</button>

<table class="table table-sm table-dark table-striped">
  <thead>
  <tr>
    <th scope="col">#</th>
    <th scope="col">Descriptor</th>
    <th scope="col">Id</th>
    <th scope="col">User</th>
    <th scope="col">Provider</th>
    <th scope="col">Quantity</th>
    <th scope="col">Price</th>
  </tr>
  </thead>
  <tbody>
  {#each offers as offer, index}
  <tr>
    <th scope="row">{index}</th>
    <td>{offer.descriptor}</td>
    <td><a class="link-light" href={offer.url}>{offer.id}</a></td>
    <td><a class="link-light" href={offer.userUrl}>{offer.userName}</a></td>
    <td>{offer.provider}</td>
    <td>{offer.quantity}</td>
    <td>{offer.price}</td>
  </tr>
  {/each}
  </tbody>
</table>
</main>